<template>
    <div class="container-products-permissions">
        <!-- <enterprise /> -->

        <units />

        <reservationsTeams :teams="teamsData" />

        <reservationsUsers :users="usersData" />

        <ui-personalize-message-modal />
    </div>
</template>

<script>
import { uiPersonalizeMessageModal } from '@/components/ui-facilita/products';
import { alertMixin } from '@/mixins';
import { reserves } from '@/services/axios';
import enterprise from './enterprise';
import reservationsTeams from './reservationsTeams';
import reservationsUsers from './reservationsUsers';
import units from './units';

export default {
    name: 'ui-products-permissions',

    components: {
        enterprise,
        units,
        reservationsTeams,
        reservationsUsers,
        uiPersonalizeMessageModal
    },

    data() {
        return {
            id: null,
            data: null,
            usersData: {},
            teamsData: {}
        }
    },

    mixins: [
		alertMixin
	],

    async mounted() {
        this.id = this.$route.params.id

        await this.load()
    },

	methods: {
		async load() {
			this.loading = true
			try {
				const response = await reserves.getConfigLimitProduct(this.id)
                this.data = response?.data?.data
                this.usersData = this.data?.users
                this.teamsData = this.data?.teams
				this.loading = false
			} catch (error) {
				if (error.data?.msg) {
					this.$mx_alertError(error.data.msg)
				}
				this.loading = false
			} finally {
				this.loading = false
			}
		}
    }
}
</script>

<style lang="stylus" scoped>
    @import './styles.styl'
</style>